import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import { format } from "date-fns";

// Body Metabolism Component Css
import * as styles from "../components/LandingPages/DiabetesConsultation/BodyMetabolism/BodyMetabolism.module.css";

const currentMonthYear = format(new Date(), "yyyy-MM"); // EX:- current month = 2025-05

const LANDING_PAGE_VIDEOS = {
  webinarBannerVideo: "https://www.youtube.com/embed/36VJm8k1zTg",
  diabetesConsultBannerVideo: "https://www.youtube.com/embed/fj8SBeLEeJ8",
  obesityBannerVideo: "https://www.youtube.com/embed/SugUlBw0Nh4",
};

const WEBINAR_LEARNING_POINTS = [
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn1.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "Why do you have diabetes in the first place?",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn2.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "How can we fix the main problem causing your diabetes?",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icn3.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "Can we find a way for you to stop taking medicine or insulin?",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn4.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "How do we figure out the best diet for you?",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn5.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "Complications of medicines",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn6.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "Difference between type 1 and type 2 diabetes",
  },
];

const WEBINAR_DOCTORSDETAILS = [
  {
    img: (
      <StaticImage
        src="../images/LandingPage/rohit_3x.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    name: "Dr Rohit warrier",
    designation:
      "MBBS, MS (UTSW,US), DABRM, EBEEDM (EuropeanBoard, Endocrinology, Diabetes & Metabolism), MSc Diab.(SouthWales,UK), CC-Diabetology (Jaipur National University/RSSDI), SCOPE cert. Obesity specialist (UK).",
    experience: "15+ Years Of Experience",
    patients: "15000+ Patients treated",
  },
  {
    img: (
      <StaticImage
        src="../images/LandingPage/dorphy_3x.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    name: "Dr Dorphy",
    designation: "MBBS MD",
    experience: "20+ Years Of Experience",
    patients: "15000+ Patients Treated",
  },
  {
    img: (
      <StaticImage
        src="../images/LandingPage/bushra_3x.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    name: "Dr Bushra Pawane",
    designation:
      "MBBS, C.DIAB, PG DIP (USA), PG DIP (UK), ADA Certified in Treatment Strategies for Diabetes and Associated Complications",
    experience: "10+ Years Of Experience",
    patients: "10000+ Patients Treated",
  },
  {
    img: (
      <StaticImage
        src="../images/LandingPage/mamtha_3x.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    name: "Dr Mamtha Prakash",
    designation:
      "MBBS, Skilled with succinct medicine, diet and lifestyle specialist",
    experience: "6+ Years Of Experience",
    patients: "5000+ Patients Treated",
  },
];

const WEBINAR_REVERSEMANAGE_HEADER = [
  "Compare",
  "Twin Health Reversal",
  "Other Treatments",
];

const WEBINAR_REVERSEMANAGE = [
  {
    category: "Goal",
    twinHealth: "✅ Reverse diabetes and heal metabolism",
    otherTreatments: "❌ Manage diabetes symptoms",
  },
  {
    category: "Approach",
    twinHealth: "✅ Personalized, science-backed, holistic",
    otherTreatments: "❌ One-size-fits-all, symptom-focused",
  },
  {
    category: "Treatment",
    twinHealth: "✅ Nutrition, sleep, activity, and lifestyle",
    otherTreatments: "❌ Focus on medicine alone",
  },
  {
    category: "Side Effects",
    twinHealth: "✅ None",
    otherTreatments: "❌ Possible organ damage",
  },
  {
    category: "Overall Health",
    twinHealth: "✅ Improves energy and mood",
    otherTreatments: "❌ Health may deteriorate",
  },
  {
    category: "Other Conditions",
    twinHealth: "✅ Helps with obesity, hypertension, and more",
    otherTreatments: "❌ Doesn’t address other conditions",
  },
];

const OBESITY_REVERSEMANAGE = [
  {
    category: "Treatment Goal",
    twinHealth: "Healthy weight loss",
    otherTreatments: "Obesity Management",
  },
  {
    category: "Treatment Philosophy",
    twinHealth:
      "Personalized, Precise, Scientific, Tech-driven, Treats root cause",
    otherTreatments: "Generic, One-size-fits-all, Treats symptoms",
  },
  {
    category: "Treatment Method",
    twinHealth:
      "Comprehensive approach: nutrition, medicine, sleep, activity & lifestyle",
    otherTreatments:
      "Risk of nutritional deficiencies, metabolic slowdown, medication side effects",
  },
  {
    category: "Sustainability",
    twinHealth: "Long-term metabolic healing",
    otherTreatments: "Short-term weight loss, high relapse rate",
  },
  {
    category: "Side Effects",
    twinHealth: "Nil",
    otherTreatments:
      "Risk of nutritional deficiencies, metabolic slowdown, medication side effects",
  },
  {
    category: "Mood & Energy",
    twinHealth: "Improves energy, mood, and daily vitality",
    otherTreatments: "Often leads to fatigue, mood swings",
  },
  {
    category: "Impact on Other Chronic Diseases",
    twinHealth: "Also helps reverse High BP, Cholesterol, NAFLD, PCOD",
    otherTreatments: "Doesn’t address root metabolic causes",
  },
];

const WEBINAR_TESTIMONIAL_DETAILS = [
  {
    userImage: (
      <StaticImage
        src="../images/LandingPage/testimonial_1.png"
        alt="testimonial"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    heading: "Alpana Mahapatra, 61, IITian",
    subHeading: "From 7.2, My HbA1c came down to 5.7",
    description:
      "While joining Twin’s Diabetes Remission Program, From 7.2, My HbA1c came down to 5.7 within One Year. This has helped improve my health & my body’s nutrition levels. Thank you so much Twin Health!",
    diseaseCure: "HbA1c",
    programStart: "7.2",
    programStartText: "Start of the program",
    yearEndValue: "5.7",
    yearText: "Within 1 Year",
  },
  {
    userImage: (
      <StaticImage
        src="../images/LandingPage/testimonial_2.png"
        alt="testimonial"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    heading: "Donald Sequeira, 63",
    subHeading: "From 3 tablets a day, now I'm down to 1",
    description:
      "I have had diabetes for the last 16 years. I joined Twin Health and the progress I've made is incredible. Today my average HbA1c is 6 and from 3 tablets a day, now I'm down to 1.",
    diseaseCure: "Medicines",
    programStart: "3",
    programStartText: "Start of the program",
    yearEndValue: "1",
    yearText: "Within 1 Year",
  },
  {
    userImage: (
      <StaticImage
        src="../images/LandingPage/testimonial_3.png"
        alt="testimonial"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    heading: "Srinivasan, diagnosed with diabetes in 2018",
    subHeading: "I wanted to save myself from type-2 diabetes",
    description:
      "I wanted to save myself from type-2 diabetes and that's when I attended a Twin Webinar. Thanks to their Diabetes Remission Program, now my HbA1c level is less than 5.8 and I'm not on medications anymore.",
    diseaseCure: "Medicines",
    programStart: "2",
    programStartText: "Start of the program",
    yearEndValue: "0",
    yearText: "Within 1 Year",
  },
  {
    userImage: (
      <StaticImage
        src="../images/LandingPage/testimonial_4.png"
        alt="testimonial"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    heading: "Divya, 34",
    subHeading: "My HbA1c levels dropped from 9.1 to 6.2",
    description:
      "I was in the Diabetes Remission Program for the past 1 year and my HbA1c levels dropped from 9.1 to 6.2 with a balanced & nutrition diet along with other everyday activities suggested by the team.",
    diseaseCure: "HbA1c",
    programStart: "9.1",
    programStartText: "Start of the program",
    yearEndValue: "6.2",
    yearText: "Within 1 Year",
  },
  {
    userImage: (
      <StaticImage
        src="../images/LandingPage/testimonial_5.png"
        alt="testimonial"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    heading: "Smidha, 43",
    subHeading: "My HbA1c was 11 & now it's at ~7.",
    description:
      "I've been in the Twin Diabetes Remission Program for the last 1 year and it's been very easy to improve my health. When I joined, My HbA1c was 11 & now it's at ~7.",
    diseaseCure: "HbA1c",
    programStart: "11",
    programStartText: "Start of the program",
    yearEndValue: "7",
    yearText: "Within 1 Year",
  },
  {
    userImage: (
      <StaticImage
        src="../images/LandingPage/testimonial_6.png"
        alt="testimonial"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    heading: "Usha, diagnosed with diabetes in 2015",
    subHeading: "Now I'm not taking any tablets",
    description:
      "One year ago my brother advised me to join the Twin Health Diabetes Remission Program. Now I'm not taking any tablets and my sugar level, every day, is around 120.",
    diseaseCure: "Sugar mg/dl",
    programStart: "350",
    programStartText: "Start of the program",
    yearEndValue: "120",
    yearText: "Within 1 Year",
    diseaseCure_2: "Medicines",
    programStart_2: "2",
    programStartText_2: "Start of the program",
    yearEndValue_2: "0",
    yearText_2: "Within 1 Year",
  },
  {
    userImage: (
      <StaticImage
        src="../images/LandingPage/testimonial_7.png"
        alt="testimonial"
        placeholder="blurred"
        loading="lazy"
      />
    ),
    heading: "Rangarajan, 63",
    subHeading: "I was free of all my diabetes medications.",
    description:
      "At the time of joining the Twin Diabetes Reversal Program, my sugar level was 280 mg/dl and HbA1c was 7.4%. Within 5 days my sugar levels came down to 70 mg and in 2 weeks, I was free of all my diabetes medications.",
    diseaseCure: "Sugar mg/dl",
    programStart: "280",
    programStartText: "Start of the program",
    yearEndValue: "70",
    yearText: "Within 1 Year",
    diseaseCure_2: "Medicines",
    programStart_2: "2",
    programStartText_2: "Start of the program",
    yearEndValue_2: "0",
    yearText_2: "Within 1 Year",
  },
];

const WEBINAR_TIMINGS = [
  // { day: 1, startTime: "19:00", endTime: "20:00" }, // Monday
  // { day: 3, startTime: "19:00", endTime: "20:00" }, // Wednesday
  // { day: 5, startTime: "19:00", endTime: "20:00" }, // Friday
  // { day: 6, startTime: "19:00", endTime: "20:00" }, // Saturday
  { day: 0, startTime: "11:00", endTime: "12:00" }, // Sunday
];

const WEBINAR_TIMER = new Date().getTime() + 24 * 60 * 60 * 1000; // 24 hours from now

const LANDING_PAGE_PARAS = {
  webinarBannerHeading:
    "Say Goodbye to Diabetes Start Your Journey to a Healthier, Diabetes-Free Life!",
  webinarBannerSubHeading:
    "Join our FREE webinar and discover the proven science behind diabetes reversal with Twin Health.",
  diabetesConsultBannerHeading:
    "Diabetes impacts you in more ways than you can imagine",
  diabetesConsultBannerSubHeading:
    "Get a one on one consultation to learn the science of diabetes reversal. Start your reversal journey",
  webinarConsultDoctorHeading: "Get All Your Queries Answered",
  webinarConsultDoctorSubHeading: "Live With Our Expert Doctor",
  diabetesConsultDoctorHeading: "Twin Medical Advisory Doctors",
  diabetesConsultOurStoryHeading: "Our Story So Far",
  diabetesConsultOurStoryFooter:
    "*Based on Randomized Control Trials conducted by Twin Health",
  obesityBannerHeading: "Lose Weight Gain Better Health",
  obesityBannerSubHeading:
    "Drop excess weight and boost your metabolism with a program customized just for you. ",
};

const DIABETES_CONSULT_OUR_STORY = [
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn6.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    heading: "2,10,000+",
    text: "Patients Treated",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn5.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    heading: "600+",
    text: "Doctors recommend",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icn3.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    heading: "~84%",
    text: "Diabetes Reversal",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn2.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    heading: "~95%",
    text: "HbA1c Less than 6.5%",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn1.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    heading: "-3.3%",
    text: "HbA1c Reduction",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn4.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    heading: "10kg",
    text: "Weight Loss",
  },
];

const MEDICAL_ADVISORY_DOCTORS = [
  {
    img: (
      <StaticImage
        src="../images/aboutUs/shashank_v2.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    name: "Padma Shri Shashank R Joshi",
    designation:
      "MBBS, MD, DM (Gold Medals), FACE (Fellow of the American College of Endocrinology), FACP (Fellow of the American College of Physicians),  FRCP (Fellow of the Royal College of Physicians) (London, Glasgow, Edinburgh)",
    experience: "30+ years of experience",
    patients: "",
  },
  {
    img: (
      <StaticImage
        src="../images/aboutUs/ambrish_v2.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    name: "Ambrish Mithal, MD",
    designation: "MBBS, MD - Medicine, DM - Endocrinology",
    experience: "40+ Years Of Experience",
    patients: "",
  },
  {
    img: (
      <StaticImage
        src="../images/aboutUs/anoop_v2.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    name: "Padma Shri Anoop Misra",
    designation: "MBBS, MD, MAMS, FIMSA (Diabetology)",
    experience: "45+ Years Of Experience",
    patients: "",
  },
  {
    img: (
      <StaticImage
        src="../images/aboutUs/ashutosh_shukla.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    name: "Dr. Ashutosh Shukla",
    designation: "MD, FCAP (Senior Consultant Physician)",
    experience: "32+ Years Of Experience",
    patients: "",
  },
];

const DIABETES_CONSULT_FAQ = [
  {
    key: "faq-01",
    index: "01",
    title: "Is diabetes reversal possible?",
    desc: "Yes! When the damaged metabolism is fixed, the insulin resistance drops, internal organ health improves & eventually the beta cells are regenerated resulting in complete diabetes reversal.",
    eventName: "Diabetes Consultation Landing Page FAQ1",
    eventDesc: "User Clicks On FAQ1 For Diabetes Consultation LP",
  },
  {
    key: "faq-02",
    index: "02",
    title:
      "Why should I go for diabetes reversal when I’m conveniently managing it?",
    desc: "Diabetes is a progressive disease that continues to get worse over time. This causes complications in every part of the body. Hence, diabetes management is not the solution but diabetes reversal is.",
    eventName: "Diabetes Consultation Landing Page FAQ2",
    eventDesc: "User Clicks On FAQ2 For Diabetes Consultation LP",
  },
  {
    key: "faq-03",
    index: "03",
    title: "Why do I need precision treatment?",
    desc: "Different people respond differently to the same food or activity. Body’s response to the same food or activity is not the same everyday. So, a treatment that precisely monitors and fixes all the inputs (nutrition, activity, sleep, breathing etc) of the metabolism is needed, to thereby heal the damaged metabolism.",
    eventName: "Diabetes Consultation Landing Page FAQ3",
    eventDesc: "User Clicks On FAQ3 For Diabetes Consultation LP",
  },
  {
    key: "faq-04",
    index: "04",
    title:
      "How is Twin Health different from programs like Breathe Wellbeing, Fitterfly, or Sugarfit?",
    desc: "At Twin Health, we go beyond fitness or diet coaching. While platforms like Breathe Wellbeing, Fitterfly Healthtech Pvt Ltd, and Sugarfit focus on lifestyle change or sugar control, Twin Health uses the world’s first Whole Body Digital Twin™ technology. This advanced AI-driven system continuously learns from your body data to create highly personalized nutrition, activity, sleep, and medical guidance. The result is not just blood sugar management but the potential for complete reversal of type 2 diabetes all from the comfort of your home.",
    eventName: "Diabetes Consultation Landing Page FAQ4",
    eventDesc: "User Clicks On FAQ4 For Diabetes Consultation LP",
  },
  {
    key: "faq-05",
    index: "05",
    title:
      "Why should I choose Twin Health instead of Fitter Fly, Cult Fit, Sugar Fit, or Breathe Well Being?",
    desc: "Brands like Fitter Fly, Cult Fit, Sugar Fit, and Breathe Well Being have helped people with fitness and wellness. However, Twin Health is uniquely designed for people who want a scientifically proven, long-term solution to reverse diabetes. With our continuous monitoring, medical team support, and personalized digital twin, you don’t just manage diabetes, you work toward sustainable reversal. That’s why thousands of members choose Twin Health over other wellness programs.",
    eventName: "Diabetes Consultation Landing Page FAQ5",
    eventDesc: "User Clicks On FAQ5 For Diabetes Consultation LP",
  },
];

const BODY_METABOLISM_COMPONENT = {
  diabetesConsultationHeading:
    "We Understand Your Body’s \n Metabolism Like No One Else",
  diabetesConsultationSubHeading:
    "Damaged metabolism is the root cause of diabetes and can severely hamper \nyour regular life. Twin Health’s program helps you understand your body's metabolism and helps in diabetic reversal in a scientific way.",
  obesityHeading:
    "Weight Gain starts with a disrupted metabolism \n not just lifestyle.",
  obesitySubHeading:
    "Twin Health, heals it with real-time data from your body.",
};

const OBESITY_FAQ = [
  {
    key: "faq-01",
    index: "01",
    title: "Why do I need precision treatment?",
    desc: "Different people respond differently to the same food or activity. Body’s response to the same food or activity is not the same everyday. So, a treatment that precisely monitors and fixes all the inputs (nutrition, activity, sleep, breathing etc) of the metabolism is needed, to thereby heal the damaged metabolism.",
    eventName: "Obesity Landing Page FAQ1",
    eventDesc: "User Clicks On FAQ1 For Obesity LP",
  },
  {
    key: "faq-02",
    index: "02",
    title: "Is weight loss really possible without medication or surgery?",
    desc: "Yes, sustainable weight loss can be achieved by addressing the root cause: a disrupted metabolism. Twin’s Whole Body Digital Twin™ identifies how your body responds to food, activity, sleep, and stress—allowing your care team to guide you with precise, personalized actions that reset your metabolism and support long-term fat loss, without pills or invasive procedures.",
    eventName: "Obesity Landing Page FAQ2",
    eventDesc: "User Clicks On FAQ2 For Obesity LP",
  },
  {
    key: "faq-03",
    index: "03",
    title: "Why haven’t diets worked for me in the past?",
    desc: "Because most diets are one-size-fits-all and only focus on calorie reduction—not your unique biology. Your metabolism is dynamic and complex. At Twin, we personalize nutrition, movement, and lifestyle using data from your body, helping you heal the underlying dysfunction and lose weight naturally and sustainably.",
    eventName: "Obesity Landing Page FAQ3",
    eventDesc: "User Clicks On FAQ3 For Obesity LP",
  },
];

const BODY_METABOLISM_DIABETES_CONSULT_CARD = [
  {
    imgSrc: (
      <StaticImage
        src="../images/LandingPage/diab-conslt-lp-bdy-icn1.png"
        alt="banner_image"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "Precision Nutrition",
  },
  {
    imgSrc: (
      <StaticImage
        src="../images/LandingPage/obesity-activity.png"
        alt="banner_image"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "Precision Activity",
  },
  {
    imgSrc: (
      <StaticImage
        src="../images/LandingPage/diab-conslt-lp-bdy-icn3.png"
        alt="banner_image"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: (
      <>
        Precision{" "}
        <span className={styles.diabConsLp__bdyMetablsm__cards__paraMobileBrk}>
          Sleep
        </span>
      </>
    ),
  },
  {
    imgSrc: (
      <StaticImage
        src="../images/LandingPage/diab-conslt-lp-bdy-icn4.png"
        alt="banner_image"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "Precision Breathing",
  },
  {
    imgSrc: (
      <StaticImage
        src="../images/LandingPage/diab-conslt-lp-bdy-icn5.png"
        alt="banner_image"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "Precision Medicine",
  },
];

const BODY_METABOLISM_OBESITY_CARD = [
  {
    imgSrc: (
      <StaticImage
        src="../images/LandingPage/diab-conslt-lp-bdy-icn1.png"
        alt="banner_image"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "Precision Nutrition",
  },
  {
    imgSrc: (
      <StaticImage
        src="../images/LandingPage/obesity-activity.png"
        alt="banner_image"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "Precision Activity",
  },
  {
    imgSrc: (
      <StaticImage
        src="../images/LandingPage/diab-conslt-lp-bdy-icn3.png"
        alt="banner_image"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: (
      <>
        Precision{" "}
        <span className={styles.diabConsLp__bdyMetablsm__cards__paraMobileBrk}>
          Sleep
        </span>
      </>
    ),
  },
  {
    imgSrc: (
      <StaticImage
        src="../images/LandingPage/diab-conslt-lp-bdy-icn4.png"
        alt="banner_image"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "Precision Breathing",
  },
  {
    imgSrc: (
      <StaticImage
        src="../images/LandingPage/stress_manage_icn.png"
        alt="banner_image"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    text: "Precision Stress Management",
  },
];

const OBESITY_OUR_STORY = [
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn6.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    heading: "1,15,000+",
    text: "Members Treated",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn5.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    heading: "600+",
    text: "Doctors recommend",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn4.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    heading: "61%",
    text: "Achieved 5% Weight Loss",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn2.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    heading: "78%",
    text: "Visceral Adiposity improved",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icnn1.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    heading: "60%",
    text: "Insulin Resistance Improved",
  },
  {
    icon: (
      <StaticImage
        src="../images/LandingPage/learn_icn3.png"
        alt="timer_icon"
        className="img-fluid"
        placeholder="blurred"
        quality={90}
      />
    ),
    heading: "87%",
    text: "Inflammation Normalised",
  },
];

const OBESITY_TESTIMONIALS = [
  {
    heading: "Lost 25 kgs & kept it off!",
    content:
      "I tried every diet, but nothing worked long-term. Twin Health helped me understand my metabolism, and I lost 25 kgs while still eating foods I love!",
    name: "Aarti M",
    age: "38",
  },
  {
    heading: "Weight loss without crash diets!",
    content:
      "Starving myself never worked. Twin Health showed me a sustainable way to lose weight by fixing my metabolism. 15 kgs down and feeling amazing!",
    name: "Rahul N",
    age: "41",
  },
  {
    heading: "No more joint pain!",
    content:
      "At 95 kgs, I struggled with knee pain. After losing 22 kgs with Twin Health, my joints feel brand new!",
    name: "Priya K",
    age: "50",
  },
  {
    heading: "More energy, less weight!",
    content:
      "Losing weight wasn’t just about looking good, it was about feeling good. I sleep better, I’m more active, and I have energy all day long!",
    name: "Anil B",
    age: "45",
  },
  {
    heading: "Finally, a weight loss plan that works!",
    content:
      "I was tired of yo-yo dieting. Twin Health helped me lose 18 kgs and, most importantly, maintain it effortlessly!",
    name: "Kavita R",
    age: "33",
  },
];

const REVERSE_OTHERS_MANAGE_CONTENT = {
  webinarHeading: "We Reverse, Others Manage",
  webinarSubHeading:
    "Twin is the first in the world to offer precision treatment to reverse diabetes with the help of \n FDA-approved sensors and AI/ML. Its comprehensive treatment includes precision nutrition, \n medicine, sleep, and activity. 100% safe, simple, and natural.",
  diabetesHeading: "We Reverse, Others Manage",
  diabetesSubHeading:
    "Twin is the first in the world to offer precision treatment to reverse diabetes with the help of \n FDA-approved sensors and AI/ML. Its comprehensive treatment includes precision nutrition, \n medicine, sleep, and activity. 100% safe, simple, and natural.",
  obesityHeading: "We Reverse, Others Manage",
  obesitySubHeading:
    "Twin is the world’s first to offer precision treatment for healthy weight loss using FDA-\n approved sensors and AI/ML.  Our 100% safe, natural approach includes personalized \n nutrition, medicine, sleep, and activity—tailored to your body.",
};

const TWIN_APP_DOWNLOAD_URLS = {
  PLAY_STORE:
    "https://play.google.com/store/apps/details?id=com.twinsdigital.v2&hl=en_IN",
  APP_STORE: "https://apps.apple.com/in/app/twin-health/id1456423142",
};

const CALENDLY_DETAILS = {
  DIABETES_CONSULTATION_HEADING: "Schedule your consultation with Twin!",
  DIABETES_CONSULT_URL: `https://calendly.com/twin-webinars/free_consultation?month=${currentMonthYear}`,
  METABOLISM_DIABETES_QUIZ_URL: `https://calendly.com/twin-reversal-webinar/1-1-consultation-msc-funnel/?month=${currentMonthYear}`,
};

const CALENDLY_MIXPANEL_PAGE_NAME = {
  DIABETES_CONSULT_LP: "twin-diabetes-consultation-landingPage",
  METABOLISM_DIABETES_QUIZ: "Metabolism Diabetes Quiz Page",
};

const constants = {
  LANDING_PAGE_VIDEOS: LANDING_PAGE_VIDEOS,
  WEBINAR_LEARNING_POINTS: WEBINAR_LEARNING_POINTS,
  WEBINAR_DOCTORSDETAILS: WEBINAR_DOCTORSDETAILS,
  WEBINAR_REVERSEMANAGE_HEADER: WEBINAR_REVERSEMANAGE_HEADER,
  WEBINAR_REVERSEMANAGE: WEBINAR_REVERSEMANAGE,
  WEBINAR_TESTIMONIAL_DETAILS: WEBINAR_TESTIMONIAL_DETAILS,
  WEBINAR_TIMINGS: WEBINAR_TIMINGS,
  WEBINAR_TIMER: WEBINAR_TIMER,
  LANDING_PAGE_PARAS: LANDING_PAGE_PARAS,
  DIABETES_CONSULT_OUR_STORY: DIABETES_CONSULT_OUR_STORY,
  MEDICAL_ADVISORY_DOCTORS: MEDICAL_ADVISORY_DOCTORS,
  DIABETES_CONSULT_FAQ: DIABETES_CONSULT_FAQ,
  BODY_METABOLISM_COMPONENT: BODY_METABOLISM_COMPONENT,
  OBESITY_FAQ: OBESITY_FAQ,
  BODY_METABOLISM_DIABETES_CONSULT_CARD: BODY_METABOLISM_DIABETES_CONSULT_CARD,
  BODY_METABOLISM_OBESITY_CARD: BODY_METABOLISM_OBESITY_CARD,
  OBESITY_OUR_STORY: OBESITY_OUR_STORY,
  OBESITY_TESTIMONIALS: OBESITY_TESTIMONIALS,
  OBESITY_REVERSEMANAGE: OBESITY_REVERSEMANAGE,
  REVERSE_OTHERS_MANAGE_CONTENT: REVERSE_OTHERS_MANAGE_CONTENT,
  TWIN_APP_DOWNLOAD_URLS: TWIN_APP_DOWNLOAD_URLS,
  CALENDLY_DETAILS: CALENDLY_DETAILS,
  CALENDLY_MIXPANEL_PAGE_NAME: CALENDLY_MIXPANEL_PAGE_NAME,
};

export default constants;
